import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid';

import { selectPartnerEmail, selectPartnerNumber } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';
import { useCopy } from '@/copy';
import { EMAIL, PHONE } from '@/utils/constants';

export const testId = 'contact-box';

export function ContactBox(): JSX.Element {
    const phoneNumber = useAppSelector(selectPartnerNumber) || PHONE;
    const email = useAppSelector(selectPartnerEmail) || EMAIL;
    const { contact, failureCard } = useCopy();
    const { heading } = contact;
    if (failureCard) {
        return (
            <div
                className='bg-white border border-cardEdge rounded-2xl p-4 mt-3 w-full _flex flex-col gap-2'
                data-testid={testId}
            >
                <p className='text-sm font-bold text-panel'>{heading}</p>
                <a
                    href={`tel:${phoneNumber}`}
                    className='_flex items-center gap-2 text-sm text-panel'
                >
                    <PhoneIcon className='h-4 w-4 shrink-0' />
                    {phoneNumber}
                </a>
                <a
                    href={`mailto:${email}`}
                    className='_flex items-center gap-2 text-sm text-panel break-all'
                >
                    <EnvelopeIcon className='h-4 w-4 shrink-0' />
                    {email}
                </a>
            </div>
        );
    }

    return (
        <div className='flex-center pt-4' data-testid={testId}>
            <div className='border-lg border-2 text-sm bg-white py-2 rounded-xl px-10 text-gray-500 text-center'>
                <h3 className='font-bold pb-4 whitespace-pre-line'>
                    {heading}
                </h3>
                <a
                    href={`tel:${phoneNumber}`}
                    className='flex-center space-x-2'
                >
                    <PhoneIcon className='h-4 w-4' />
                    <p>{phoneNumber}</p>
                </a>
                <a href={`mailto:${email}`} className='flex-center space-x-2'>
                    <EnvelopeIcon className='h-4 w-4' />
                    <p>{email}</p>
                </a>
            </div>
        </div>
    );
}
